import { ScoreOption } from '@/modules/teacher/SaitenList';
import _ from 'lodash';
import moment from 'moment';
import { mathjax } from 'mathjax-full/js/mathjax.js';
import { TeX } from 'mathjax-full/js/input/tex.js';
import { SVG } from 'mathjax-full/js/output/svg.js';
import { liteAdaptor } from 'mathjax-full/js/adaptors/liteAdaptor.js';
import { RegisterHTMLHandler } from 'mathjax-full/js/handlers/html.js';
import { AllPackages  } from 'mathjax-full/js/input/tex/AllPackages.js';

/***************************
 * userの権限
 ***************************/
export enum RoleEnum {
  Admin = "admin",
  Teacher1 = "teacher1",
  Teacher2 = "teacher2",
  Student = "student",
  EntranceTeacher1 = "entrance_teacher1",
  EntranceTeacher2 = "entrance_teacher2",
  DigitalPaper = "digital_paper",
  PracticeExaminee = "p_examinee",
}

export enum RoleNameEnum {
  Admin = "システム管理者",
  Teacher1 = "管理者",
  Teacher2 = "一般",
  Student = "生徒",
  EntranceTeacher1 = "入試管理者",
  EntranceTeacher2 = "入試一般"
}

export interface ComboboxRole {
  value: string
  text: string
}

// プルダウン・ラジオボタン用 AdminとStudentは使用しない
export function GetComboboxRoleArray() :ComboboxRole[]{
  const rtn: ComboboxRole[] = [];
  rtn.push({value: RoleEnum.Teacher1, text: RoleNameEnum.Teacher1});
  rtn.push({value: RoleEnum.Teacher2, text: RoleNameEnum.Teacher2});
  rtn.push({value: RoleEnum.EntranceTeacher1, text: RoleNameEnum.EntranceTeacher1});
  rtn.push({value: RoleEnum.EntranceTeacher2, text: RoleNameEnum.EntranceTeacher2});
  return rtn;
}

// プルダウン・ラジオボタン用 AdminとStudentは使用しない
export function GetComboboxTeacherRoleArray() :ComboboxRole[]{
  const rtn: ComboboxRole[] = [];
  rtn.push({value: RoleEnum.Teacher1, text: RoleNameEnum.Teacher1});
  rtn.push({value: RoleEnum.Teacher2, text: RoleNameEnum.Teacher2});
  return rtn;
}

// プルダウン・ラジオボタン用 AdminとStudentは使用しない
export function GetComboboxEntranceTeacherRoleArray() :ComboboxRole[]{
  const rtn: ComboboxRole[] = [];
  rtn.push({value: RoleEnum.EntranceTeacher1, text: RoleNameEnum.EntranceTeacher1});
  rtn.push({value: RoleEnum.EntranceTeacher2, text: RoleNameEnum.EntranceTeacher2});
  return rtn;
}

/***************************
 * 学年
 ***************************/
export enum GradeEnum {
  Chu1 = 1,
  Chu2 = 2,
  Chu3 = 3,
  Kou1 = 4,
  Kou2 = 5,
  Kou3 = 6,
  Syo1 = 7,
  Syo2 = 8,
  Syo3 = 9,
  Syo4 = 10,
  Syo5 = 11,
  Syo6 = 12,
}

export enum GradeNameEnum {
  Chu1 = "中1",
  Chu2 = "中2",
  Chu3 = "中3",
  Kou1 = "高1",
  Kou2 = "高2",
  Kou3 = "高3",
  Syo1 = "小1",
  Syo2 = "小2",
  Syo3 = "小3",
  Syo4 = "小4",
  Syo5 = "小5",
  Syo6 = "小6",
}

export interface ComoboxGrade {
  value: number
  text: string
}

export function GetComboboxGradeArray() :ComoboxGrade[] {
  const rtn: ComoboxGrade[] = [];
  rtn.push({value: GradeEnum.Chu1, text: GradeNameEnum.Chu1});
  rtn.push({value: GradeEnum.Chu2, text: GradeNameEnum.Chu2});
  rtn.push({value: GradeEnum.Chu3, text: GradeNameEnum.Chu3});
  rtn.push({value: GradeEnum.Kou1, text: GradeNameEnum.Kou1});
  rtn.push({value: GradeEnum.Kou2, text: GradeNameEnum.Kou2});
  rtn.push({value: GradeEnum.Kou3, text: GradeNameEnum.Kou3});
  rtn.push({value: GradeEnum.Syo1, text: GradeNameEnum.Syo1});
  rtn.push({value: GradeEnum.Syo2, text: GradeNameEnum.Syo2});
  rtn.push({value: GradeEnum.Syo3, text: GradeNameEnum.Syo3});
  rtn.push({value: GradeEnum.Syo4, text: GradeNameEnum.Syo4});
  rtn.push({value: GradeEnum.Syo5, text: GradeNameEnum.Syo5});
  rtn.push({value: GradeEnum.Syo6, text: GradeNameEnum.Syo6});
  return rtn;
}

export function GetGradeNameByGrade(grade: number) :string {
  if(grade == GradeEnum.Chu1){
    return GradeNameEnum.Chu1;
  }else if(grade == GradeEnum.Chu2){
    return GradeNameEnum.Chu2;
  }else if(grade == GradeEnum.Chu3){
    return GradeNameEnum.Chu3;
  }else if(grade == GradeEnum.Syo1){
    return GradeNameEnum.Syo1;
  }else if(grade == GradeEnum.Syo2){
    return GradeNameEnum.Syo2;
  }else if(grade == GradeEnum.Syo3){
    return GradeNameEnum.Syo3;
  }else if(grade == GradeEnum.Syo4){
    return GradeNameEnum.Syo4;
  }else if(grade == GradeEnum.Syo5){
    return GradeNameEnum.Syo5;
  }else if(grade == GradeEnum.Syo6){
    return GradeNameEnum.Syo6;
  }else if(grade == GradeEnum.Kou1){
    return GradeNameEnum.Kou1;
  }else if(grade == GradeEnum.Kou2){
    return GradeNameEnum.Kou2;
  }else if(grade == GradeEnum.Kou3){
    return GradeNameEnum.Kou3;
  }else{
    return "";
  }
}

/***************************
 * 実施月 プルダウン用
 ***************************/
export interface ComoboxMonth {
  value: number
  text: string
}

export function GetComboboxMonthArray() :ComoboxMonth[] {
  const rtn: ComoboxMonth[] = [];
  rtn.push({value: 1, text: "1月"});
  rtn.push({value: 2, text: "2月"});
  rtn.push({value: 3, text: "3月"});
  rtn.push({value: 4, text: "4月"});
  rtn.push({value: 5, text: "5月"});
  rtn.push({value: 6, text: "6月"});
  rtn.push({value: 7, text: "7月"});
  rtn.push({value: 8, text: "8月"});
  rtn.push({value: 9, text: "9月"});
  rtn.push({value: 10, text: "10月"});
  rtn.push({value: 11, text: "11月"});
  rtn.push({value: 12, text: "12月"});
  return rtn;
}

/***************************
 * 学校ごとに付与されるオプション情報
 ***************************/
export enum SchoolOptionEnum {
  StudentManage = 1,
  Cbt = 2,
  Entrance = 3,
  TwoFactor = 4,
  Classroom = 5,
  DigitalPaper = 6,
  MailReturn = 7,
  Practice = 8,
  Homework = 9,
  SheetViewCreateUserOnlyActive = 10,
  SortAnswerImageRequired = 11,
  SchoolSubject = 12,
  Teams = 13,
}

/***************************
 * 試験種別
 ***************************/
export enum SheetTypeEnum {
  Normal = 0,
  Cbt = 1,
  Entrance = 2,
  Practice = 3,
  Homework = 4,
  EntranceCompare = 5,
  PracticeCompare = 6,
}

/***************************
 * API連携種別Api
 ***************************/
export enum ApiTypeEnum {
  None = 0,
  Classroom = 1,
  Teams = 2,
}

/***************************
 * sheet_field.kind Enum
 * api側のConstantsと同じ定義にすること
 ***************************/
export enum SheetFieldKindEnum {
  FIELD = 0,
  TOTAL_SCORE = 10,
  PART1 = 11,
  VIEW_POINT = 12,
  STUDENT_INFO = 9,
  STUDENT_KEY_RECOG = 13,
}

/***************************
 * sheet_field.scoring_type Enum
 * api側のConstantsと同じ定義にすること
 ***************************/
 export enum ScoringTypeEnum {
  Seigo = 1,
  ScoreStampPlus = 2,
  ScoreStampMinus = 3,
}

/***************************
 * field_activity.correct_state Enum
 ***************************/
export enum CorrectStateEnum {
  Seitou = 1,
  Gotou = -1,
  Tokuten = 0
}

/***************************
 * scoring_type プルダウン用
 ***************************/
 export interface ComoboxScoingType {
  value: number
  text: string
}

export function GetComboboxScoingTypeArray() :ComoboxScoingType[] {
  const rtn: ComoboxScoingType[] = [];
  rtn.push({value: ScoringTypeEnum.Seigo, text: GetScoringTypeNameByCode(ScoringTypeEnum.Seigo)});
  rtn.push({value: ScoringTypeEnum.ScoreStampPlus, text: GetScoringTypeNameByCode(ScoringTypeEnum.ScoreStampPlus)});
  rtn.push({value: ScoringTypeEnum.ScoreStampMinus, text: GetScoringTypeNameByCode(ScoringTypeEnum.ScoreStampMinus)});
  return rtn;
}

export function IsScoringTypeScoreStamp(scoring_type: number) :boolean {
  return scoring_type == ScoringTypeEnum.ScoreStampPlus || scoring_type == ScoringTypeEnum.ScoreStampMinus
}

export function GetScoringTypeNameByCode(code: number){
  let rtn = "";
  if(code == ScoringTypeEnum.Seigo){
    rtn = "標準方式";
  }else if(code == ScoringTypeEnum.ScoreStampPlus){
    rtn = "加点スタンプ方式";
  }else if(code == ScoringTypeEnum.ScoreStampMinus){
    rtn = "減点スタンプ方式";
  }
  return rtn;
}

/***************************
 * 正答 プルダウン用
 ***************************/
 export interface ComoboxCorrectText {
  value: string
  text: string
}

export function GetComboboxCorrectTextArray() :ComoboxCorrectText[] {
  const rtn: ComoboxCorrectText[] = [];
  rtn.push({value: "ア", text: "ア"});
  rtn.push({value: "イ", text: "イ"});
  rtn.push({value: "ウ", text: "ウ"});
  rtn.push({value: "エ", text: "エ"});
  rtn.push({value: "オ", text: "オ"});
  rtn.push({value: "カ", text: "カ"});
  rtn.push({value: "キ", text: "キ"});
  rtn.push({value: "ク", text: "ク"});
  rtn.push({value: "ケ", text: "ケ"});
  rtn.push({value: "コ", text: "コ"});
  rtn.push({value: "0", text: "0"});
  rtn.push({value: "1", text: "1"});
  rtn.push({value: "2", text: "2"});
  rtn.push({value: "3", text: "3"});
  rtn.push({value: "4", text: "4"});
  rtn.push({value: "5", text: "5"});
  rtn.push({value: "6", text: "6"});
  rtn.push({value: "7", text: "7"});
  rtn.push({value: "8", text: "8"});
  rtn.push({value: "9", text: "9"});
  return rtn;
}

/***************************
 * 文字認識の種別 Enum
 ***************************/
export enum RecogTypeEnum {
  SingleNumber = 1,
  SingleAlpha = 2,
  SingleKana = 3,
  SingleHira = 4,
  SingleKanNumber = 5,
  SingleYesNo = 6,
  EnglishWord = 7,
  EnglishSentence = 8,
  Math = 9,
}

export interface ComoboxRecogType {
  value: number
  text: string
}

export function GetComboboxRecogTypeArray() :ComoboxDigitalAnswerType[] {
  const rtn: ComoboxDigitalAnswerType[] = [];
  rtn.push({value: RecogTypeEnum.SingleNumber, text: GetRecogTypeNameByCode(RecogTypeEnum.SingleNumber)});
  rtn.push({value: RecogTypeEnum.SingleAlpha, text: GetRecogTypeNameByCode(RecogTypeEnum.SingleAlpha)});
  rtn.push({value: RecogTypeEnum.SingleKana, text: GetRecogTypeNameByCode(RecogTypeEnum.SingleKana)});
  rtn.push({value: RecogTypeEnum.SingleHira, text: GetRecogTypeNameByCode(RecogTypeEnum.SingleHira)});
  rtn.push({value: RecogTypeEnum.SingleKanNumber, text: GetRecogTypeNameByCode(RecogTypeEnum.SingleKanNumber)});
  rtn.push({value: RecogTypeEnum.SingleYesNo, text: GetRecogTypeNameByCode(RecogTypeEnum.SingleYesNo)});
  rtn.push({value: RecogTypeEnum.EnglishWord, text: GetRecogTypeNameByCode(RecogTypeEnum.EnglishWord)});
  // rtn.push({value: RecogTypeEnum.EnglishSentence, text: GetRecogTypeNameByCode(RecogTypeEnum.EnglishSentence)});
  rtn.push({value: RecogTypeEnum.Math, text: GetRecogTypeNameByCode(RecogTypeEnum.Math)});
  return rtn;
}

export function GetRecogTypeNameByCode(code: number){
  let rtn = "";
  if(code == RecogTypeEnum.SingleNumber){
    rtn = "数字1文字（0～9）";
  }else if(code == RecogTypeEnum.SingleAlpha){
    rtn = "アルファベット1文字（A～F, a～f）";
  }else if(code == RecogTypeEnum.SingleKana){
    rtn = "カタカナ1文字（ア～チ）";
  }else if(code == RecogTypeEnum.SingleHira){
    rtn = "ひらがな1文字（あ～こ）";
  }else if(code == RecogTypeEnum.SingleKanNumber){
    rtn = "漢数字1文字（一～九）";
  }else if(code == RecogTypeEnum.SingleYesNo){
    rtn = "マルバツ1文字（○・×）";
  }else if(code == RecogTypeEnum.EnglishWord){
    rtn = "英単語";
  }else if(code == RecogTypeEnum.EnglishSentence){
    rtn = "英文";
  }else if(code == RecogTypeEnum.Math){
    rtn = "数式";
  }
  return rtn;
}

export function IsSingleCharRecog(code: number){
  return [RecogTypeEnum.SingleNumber, RecogTypeEnum.SingleAlpha, RecogTypeEnum.SingleKana, RecogTypeEnum.SingleHira, RecogTypeEnum.SingleKanNumber, RecogTypeEnum.SingleYesNo].includes(code);
}

export interface ComoboxRecogChar {
  value: number
  text: string
}

export function GetComboboxRecogCharArray(recog_type: number){
  let rtn: ComoboxRecogChar[] = [];
  
  if(recog_type == RecogTypeEnum.SingleNumber){
    rtn.push({value: 0, text: "0"});
    rtn.push({value: 1, text: "1"});
    rtn.push({value: 2, text: "2"});
    rtn.push({value: 3, text: "3"});
    rtn.push({value: 4, text: "4"});
    rtn.push({value: 5, text: "5"});
    rtn.push({value: 6, text: "6"});
    rtn.push({value: 7, text: "7"});
    rtn.push({value: 8, text: "8"});
    rtn.push({value: 9, text: "9"});
  }else if(recog_type == RecogTypeEnum.SingleAlpha){
    rtn.push({value: 0, text: "Aa"});
    rtn.push({value: 1, text: "Bb"});
    rtn.push({value: 2, text: "Cc"});
    rtn.push({value: 3, text: "Dd"});
    rtn.push({value: 4, text: "Ee"});
    rtn.push({value: 5, text: "Ff"});
  }else if(recog_type == RecogTypeEnum.SingleKana){
    rtn.push({value: 0, text: "ア"});
    rtn.push({value: 1, text: "イ"});
    rtn.push({value: 2, text: "ウ"});
    rtn.push({value: 3, text: "エ"});
    rtn.push({value: 4, text: "オ"});
    rtn.push({value: 5, text: "カ"});
    rtn.push({value: 6, text: "キ"});
    rtn.push({value: 7, text: "ク"});
    rtn.push({value: 8, text: "ケ"});
    rtn.push({value: 9, text: "コ"});
    rtn.push({value: 10, text: "サ"});
    rtn.push({value: 11, text: "シ"});
    rtn.push({value: 12, text: "ス"});
    rtn.push({value: 13, text: "セ"});
    rtn.push({value: 14, text: "ソ"});
    rtn.push({value: 15, text: "タ"});
    rtn.push({value: 16, text: "チ"});
  }else if(recog_type == RecogTypeEnum.SingleHira){
    rtn.push({value: 0, text: "あ"});
    rtn.push({value: 1, text: "い"});
    rtn.push({value: 2, text: "う"});
    rtn.push({value: 3, text: "え"});
    rtn.push({value: 4, text: "お"});
    rtn.push({value: 5, text: "か"});
    rtn.push({value: 6, text: "き"});
    rtn.push({value: 7, text: "く"});
    rtn.push({value: 8, text: "け"});
    rtn.push({value: 9, text: "こ"});
  }else if(recog_type == RecogTypeEnum.SingleKanNumber){
    rtn.push({value: 0, text: "二"});
    rtn.push({value: 1, text: "三"});
    rtn.push({value: 2, text: "四"});
    rtn.push({value: 3, text: "五"});
    rtn.push({value: 4, text: "六"});
    rtn.push({value: 5, text: "七"});
    rtn.push({value: 6, text: "八"});
    rtn.push({value: 7, text: "九"});
  }else if(recog_type == RecogTypeEnum.SingleYesNo){
    rtn.push({value: 0, text: "o"});
    rtn.push({value: 1, text: "x"});
  }

  return rtn;
}

export const getCorrectText = (recog_type: number, text: string) => {
  if(text != null && recog_type == RecogTypeEnum.SingleAlpha){
    if(["A", "a"].includes(text)){
      return "Aa";
    }else if(["B", "b"].includes(text)){
      return "Bb";
    }else if(["C", "c"].includes(text)){
      return "Cc";
    }else if(["D", "d"].includes(text)){
      return "Dd";
    }else if(["E", "e"].includes(text)){
      return "Ee";
    }else if(["F", "f"].includes(text)){
      return "Ff";
    }
  }else{
    return text;
  }
}

/***************************
 * sheet_field.answer_type Enum
 * api側のConstantsと同じ定義にすること
 ***************************/
 export enum DigialAnswerTypeEnum {
  Both = 1,
  Draw = 2,
  Text = 3,
  Image = 4,
}

export interface ComoboxDigitalAnswerType {
  value: number
  text: string
}

export function GetComboboxDigitalAnswerTypeArray() :ComoboxDigitalAnswerType[] {
  const rtn: ComoboxDigitalAnswerType[] = [];
  rtn.push({value: DigialAnswerTypeEnum.Both, text: GetDigitalAnswerTypeNameByCode(DigialAnswerTypeEnum.Both)});
  rtn.push({value: DigialAnswerTypeEnum.Draw, text: GetDigitalAnswerTypeNameByCode(DigialAnswerTypeEnum.Draw)});
  rtn.push({value: DigialAnswerTypeEnum.Text, text: GetDigitalAnswerTypeNameByCode(DigialAnswerTypeEnum.Text)});
  return rtn;
}

export function GetDigitalAnswerTypeNameByCode(code: number){
  let rtn = "";
  if(code == DigialAnswerTypeEnum.Both){
    rtn = "手書き・テキスト";
  }else if(code == DigialAnswerTypeEnum.Draw){
    rtn = "手書きのみ";
  }else if(code == DigialAnswerTypeEnum.Text){
    rtn = "テキスト";
  }
  return rtn;
}

/***************************
 * practice_ecaminee.gender Enum
 * api側のConstantsと同じ定義にすること
 ***************************/
 export enum GenderEnum {
  Man = 1,
  Woman = 2,
  Unknown = 0,
}

export interface ComoboxGeder {
  value: number
  text: string
}

export function GetComboboxGenderArray() :ComoboxDigitalAnswerType[] {
  const rtn: ComoboxDigitalAnswerType[] = [];
  rtn.push({value: GenderEnum.Man, text: GetGenderNameByCode(GenderEnum.Man)});
  rtn.push({value: GenderEnum.Woman, text: GetGenderNameByCode(GenderEnum.Woman)});
  rtn.push({value: GenderEnum.Unknown, text: GetGenderNameByCode(GenderEnum.Unknown)});
  return rtn;
}

export function GetGenderNameByCode(code: number){
  let rtn = "";
  if(code == GenderEnum.Man){
    rtn = "男子";
  }else if(code == GenderEnum.Woman){
    rtn = "女子";
  }else if(code == GenderEnum.Unknown){
    rtn = "なし";
  }
  return rtn;
}

/***************************
 * sumup_unit.unit_type Enum
 * api側のConstantsと同じ定義にすること
 ***************************/
 export enum SumupUnitTypeEnum {
  SingleCurriculum = 1,
  MultiCurriculum = 2,
  MultiUnit = 3,
  Course = 4,
}

export interface ComoboxSumupUnitType {
  value: number
  text: string
}

/***************************
 * sumup_group.assessment_score_type Enum
 * api側のConstantsと同じ定義にすること
 ***************************/
 export enum AssessmentScoreTypeEnum {
  TotalScore = 1,
  StdScore = 2,
}

export interface ComoboxAssessmentScoreType {
  value: number
  text: string
}

export function GetComboboxAssessmentScoreTypeArray() :ComoboxAssessmentScoreType[] {
  const rtn: ComoboxAssessmentScoreType[] = [];
  rtn.push({value: AssessmentScoreTypeEnum.TotalScore, text: GetAssessmentScoreTypeNameByCode(AssessmentScoreTypeEnum.TotalScore)});
  rtn.push({value: AssessmentScoreTypeEnum.StdScore, text: GetAssessmentScoreTypeNameByCode(AssessmentScoreTypeEnum.StdScore)});
  return rtn;
}

export function GetAssessmentScoreTypeNameByCode(code: number){
  let rtn = "";
  if(code == AssessmentScoreTypeEnum.TotalScore){
    rtn = "得点";
  }else if(code == AssessmentScoreTypeEnum.StdScore){
    rtn = "偏差値";
  }
  return rtn;
}

/***************************
 * 採点完了後に次の採点に移動するときの種別
 * Field:次の設問 Room:次の教室
 ***************************/
export enum NextFieldTypeEnum {
  Field = 1,
  Room = 2,
}

/***************************
 * 答案画像種別
 * 1: スキャン画像
 * 2: 採点結果合成画像
 * 3: レビュー合成画像
 ***************************/
export enum AnswerImageTypeEnum {
  Scan = 1,
  ScoringResult = 2,
  Reviewed = 3,
}

/***************************
 * デジタルペーパー・課題ステータス
 * 1: 解答中
 * 2: 自己採点中
 * 3: 提出済み
 ***************************/
export const StudentSheetStatusEnum = Object.freeze({
  Answering: 1,
  SelfScoring: 2,
  Scoring: 3,
  Failure: 4,
  Pass: 5,
});

/***************************
 * スタンプ種別
 ***************************/
export enum StmapTypeEnum {
  Text = 1,
  Image = 2,
}

/***************************
 * API Getのクエリ生成
 ***************************/
export function BuildQuery(object: any, namespace: string) :string {
  return _.map(object, (value: any, key: any) => {
    return namespace ? `${namespace}[${encodeURIComponent(key)}]=${encodeURIComponent(value)}` : `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
  }).join('&');
}

/***************************
 * 時刻を指定されたフォーマットに変換
 ***************************/
export function formatDate(value: any, format: string) :string {
  if (value === null || value === "") {
    return "";
  }
  var datetimeAt = new Date(value);
  return moment(datetimeAt).format(format);
}

/***************************
 * 数字配列の合計値を取得
 ***************************/
export function sumArray(array: number[]) {
  let sum = 0;
  for (let i = 0, len = array.length; i < len; i++) {
    sum += array[i];
  }
  return sum;
}

/***************************
 * 試験一覧のページあたりの行数
 ***************************/
export const SheetListRowCount = 20;

/***************************
 * スクロール
 ***************************/
export function smoothScroll(fromTop: number, toTop: number, fromLeft: number, toLeft: number, elem: HTMLElement): Promise<void> {
  const duration = 300; // アニメーションの時間（ミリ秒）
  const framesPerSecond = 60; // 1秒あたりのフレーム数
  const frameInterval = 1000 / framesPerSecond; // フレームの間隔（ミリ秒）

  let scrollLeft = fromLeft;
  let scrollTop = fromTop;

  const rangeH = (toTop - fromTop) / (duration / frameInterval);
  const rangeV = (toLeft - fromLeft) / (duration / frameInterval);

  return new Promise<void>(resolve => {
    const move = function () {
      if ((rangeH > 0 && scrollTop + rangeH > toTop) || (rangeH < 0 && scrollTop + rangeH < toTop)) {
        scrollTop = toTop;
      } else {
        scrollTop += rangeH;
      }

      if ((rangeV > 0 && scrollLeft + rangeV > toLeft) || (rangeV < 0 && scrollLeft + rangeV < toLeft)) {
        scrollLeft = toLeft;
      } else {
        scrollLeft += rangeV;
      }

      // スクロールさせる
      elem.scrollTo(scrollLeft, scrollTop);

      // 現在位置が目的位置より進んでいなければアニメーションを続行させる
      if ((rangeH > 0 && scrollTop < toTop) || (rangeH < 0 && scrollTop > toTop) || (rangeV > 0 && scrollLeft < toLeft) || (rangeV < 0 && scrollLeft > toLeft)) {
        setTimeout(move, frameInterval);
      } else {
        resolve();
      }
    };
    move(); // 初回呼び出し
  });
}

/**
 * 整数チェック
 * @param value 
 */
export const isInteger = (value: string): boolean => {

  if (!value) {
    return false;
  }

  const number = Number(value);

  return !isNaN(number) && isFinite(number) && (value.toString().length == parseInt(value).toString().length) && (value.toString().indexOf(".") == -1);
}

/**
 * 浮動小数点チェック
 * @param value
 * @returns 
 */
export const isFloat = (value: string): boolean => {
  const regex = /^[+-]?[0-9]+\.[0-9]+([eE][+-]?[0-9]+)?$/;
  return regex.test(value);
}

/**
 * 整数 or 浮動小数点数かチェック
 * @param value 
 */
export const isFloatOrInteger = (value: string): boolean => {
  return isInteger(value) || isFloat(value);
}

/**
 * ファイル名から拡張子取得
 * @param fileName 
 * @returns 
 */
export const getFileExtension = (fileName: string) => {
  var fileNameSplitArray = fileName.split('.');

  if(fileNameSplitArray.length == 1){
    return "";
  }else{
    return fileNameSplitArray[fileNameSplitArray.length - 1].toLowerCase();
  }
}

/************************************************************
 * Windowsのフォルダ名前順ソートロジックで並び替え
 * StrCmpLogicalW 関数を再現
 ************************************************************/

export const strCmpLogicalW = (str1: string, str2: string): number => {
  // 数値部分を抽出する正規表現パターンを定義
  const pattern = /(\d+)|(\D+)/g;
  
  // 文字列を数値部分と非数値部分に分割する
  const parts1 = str1.match(pattern) ?? [];
  const parts2 = str2.match(pattern) ?? [];
  
  // 数値部分を数値に変換して、文字列の比較を行う
  for (let i = 0; i < parts1.length && i < parts2.length; i++) {
    const part1 = parts1[i];
    const part2 = parts2[i];
    
    if (/\d/.test(part1) && /\d/.test(part2)) {
      // 数値部分同士の比較
      const num1 = parseInt(part1, 10);
      const num2 = parseInt(part2, 10);
      if (num1 !== num2) {
        return num1 < num2 ? -1 : 1;
      }
    } else {
      // 非数値部分同士の比較
      if (part1 !== part2) {
        return part1 < part2 ? -1 : 1;
      }
    }
  }
  
  // 全ての部分が同じ場合は、長さで比較する
  return str1.length - str2.length;
}


/************************************************************
 * テキスト画像サイズ取得時に使用する定数
 ************************************************************/

 export const lineScale = 1.1618;

 /************************************************************
  * テキスト画像のサイズ取得
  ************************************************************/

  export type GetTextSizeOptions = {
    text?: string;
    fontSize: number;
    lineHeight?: number;
    letterSpacing?: number;
    direction?: number;
    defaultText?: string;
    fontFamily?: string;
  };

  export const getTextSize = ({
    text = null,
    fontSize,
    lineHeight = 0,
    direction = DirectionEnum.Horizon,
    defaultText = "テキスト",
    fontFamily = "serif",
  }: GetTextSizeOptions) => {
    text = text ? text : defaultText;
    let size = null;
    if(direction == DirectionEnum.Horizon){
      size = getTextSizeHorizon({text: text, fontSize: fontSize, lineHeight: lineHeight, fontFamily: fontFamily});
    }else if(direction == DirectionEnum.Vertical){
      size = getTextSizeVertical({text: text, fontSize: fontSize, lineHeight: lineHeight, fontFamily: fontFamily});
    }
    return size;
  };
 
  export const getTextSize_ = (text: string, fontSize: number, lineHeight: number, direction: number = DirectionEnum.Horizon, defaultText: string = "テキスト", fontFamily: string = "serif") => {
   text = text ? text : defaultText;
   const canvas = document.createElement('canvas') as HTMLCanvasElement;
   const ctx = canvas.getContext('2d');
   ctx.font = `${fontSize}px ${fontFamily}`;
 
   let width = 0;
   let height = 0;
   const lines = text.split("\n");
 
   for(let i = 0; i < lines.length; i++){
     const metrics = ctx.measureText(lines[i]);
     width = metrics.width > width ? metrics.width : width;
     height += Number(fontSize) * lineScale;
     height += i == lines.length - 1 ? 0 : Number(lineHeight);
   }
   height += Number(fontSize) * (lineScale - 1);
 
   return new Size(width, height);
 }

/************************************************************
 * 横書きテキスト画像のサイズ取得
 ************************************************************/

 export const getTextSizeHorizon = ({
    text,
    fontSize,
    lineHeight,
    fontFamily = "serif",
  }: GetTextSizeOptions) => {
  const canvas = document.createElement('canvas') as HTMLCanvasElement;
  const ctx = canvas.getContext('2d');
  ctx.font = `${fontSize}px ${fontFamily}`;

  let width = 0;
  let height = 0;
  const lines = text.split("\n");

  for(let i = 0; i < lines.length; i++){
    const metrics = ctx.measureText(lines[i]);
    width = metrics.width > width ? metrics.width : width;
    height += Number(fontSize) * lineScale;
    height += i == lines.length - 1 ? 0 : Number(lineHeight);
  }
  height += Number(fontSize) * (lineScale - 1);

  return new Size(width, height);
}

/************************************************************
 * テキスト画像のBase64生成
 ************************************************************/

export const createBase64Text = (obj: any, defaultText: string = "テキスト") => {
  let base64Text = null;
  if(obj.direction == DirectionEnum.Horizon){
    base64Text = createBase64TextHorizon(obj, defaultText);
  }else if(obj.direction == DirectionEnum.Vertical){
    base64Text = createBase64TextVertical(obj, defaultText);
  }
  return base64Text;
}

/************************************************************
 * 横書きテキスト画像のBase64生成
 ************************************************************/

export const createBase64TextHorizon = (obj: any, defaultText: string) => {
  const text = obj.text ? obj.text : defaultText;
  const canvas = document.createElement('canvas') as HTMLCanvasElement;
  canvas.width = obj.width;
  canvas.height = obj.height;
  const ctx = canvas.getContext('2d');
  const fontFamily = 'font_family' in obj && obj.font_family ? obj.font_family : "serif";
  ctx.font = `${obj.font_size}px ${fontFamily}`;
  ctx.fillStyle = obj.color;
  let y = 0;
  const lines = text.split("\n");
  for(let i = 0; i < lines.length; i++){
    y += i == 0 ? Number(obj.font_size) : Number(obj.font_size) * lineScale;
    ctx.fillText(lines[i], 0, y);
    y += Number(obj.line_height);
  }
  return canvas.toDataURL("image/png").replace("data:image/png;base64,", "");
}

/************************************************************
 * 縦書きテキスト画像のBase64生成
 ************************************************************/

export const createBase64TextVertical = (obj: any, defaultText: string) => {

  const text = obj.text ? obj.text : defaultText;
  const letterSpacing = 0;
  const textSize = getTextSizeVertical({text: text, fontSize: obj.font_size, lineHeight: obj.line_height});
  const width = textSize.width;
  const height = textSize.height;

  const canvas = document.createElement("canvas");

  // 幅、高さを整数で設定
  canvas.width = Math.ceil(width);
  canvas.height = Math.ceil(height);
  canvas.style.cssText = "margin: 0px; padding: 0px; line-height: 0px";

  const ctx = canvas.getContext("2d");
  const fontFamily = 'font_family' in obj && obj.font_family ? obj.font_family : "serif";
  ctx.font = `${obj.font_size}px ${fontFamily}`;
  ctx.fillStyle = obj.color;

  const textArray = text.split(/\r\n|\r|\n/);

  // 1行あたりの幅
  const rowWidthPer = width / textArray.length;

  const baseCharSize = getBaseSizeOfSingleChar(obj.font_size, fontFamily);

  const baseYPos = baseCharSize.fontBoundingBoxAscent;

  // 左から画像作成の為、配列の要素数は最大から減算
  for (let rowNo = textArray.length - 1, i = 0; rowNo >= 0; rowNo--, i++) {

    const text = textArray[rowNo];

    const xPos = rowWidthPer * i;

    for (let colNo = 0; colNo < text.length; colNo++) {

      const word = text.charAt(colNo);
      const nextWord = text.charAt(colNo + 1);

      // Y軸位置
      const yPos = baseYPos + ((parseInt(obj.font_size) + letterSpacing) * colNo);

      if (word == "！" || word == "？") {

        /* ** ！？連続表示 ** */

        if (nextWord == "！" || nextWord == "？") {

          ctx.fillText(word, xPos - (obj.font_size * 0.25), yPos);
          ctx.fillText(nextWord, xPos + (obj.font_size * 0.25), yPos);

          // 同一行と列に2文字表示する為、次の文字を表示する為、+1
          colNo = colNo + 1;
        } else {
          ctx.fillText(word, xPos, yPos);
        }
      } else {

        // 回転時 fillText(文字, 上下(数字が小さいほど上), 左右(数字が小さいほど右))
        // 通常時 fillText(文字, 左右(数字が大きいほど右), 上下(数字が大きいほど下))

        if (word.match(/[「『（）＜＞【】〔〕≪≫＜＞～―…：；{}｛｝]/)) {
          ctx.save();
          ctx.setTransform(1, 0, 0, 1, 0, 0);
          ctx.rotate(90 * Math.PI / 180);
          ctx.fillText(word, yPos - obj.font_size * 0.75, -xPos - obj.font_size * 0.12);
          ctx.restore();
        } else if (word.match(/[」』]/)) {
          ctx.save();
          ctx.setTransform(1, 0, 0, 1, 0, 0);
          ctx.rotate(90 * Math.PI / 180);
          ctx.fillText(word, yPos - obj.font_size * 1, -xPos - obj.font_size * 0.12);
          ctx.restore();
        } else if (word.match(/[-=ー＝]/)) {
          ctx.save();
          ctx.setTransform(1, 0, 0, 1, 0, 0);
          ctx.rotate(90 * Math.PI / 180);
          ctx.fillText(word, yPos - obj.font_size * 0.75, -xPos - obj.font_size * 0.2);
          ctx.restore();
        } else if (word.match(/[。]/)) {
          ctx.save();
          ctx.setTransform(1, 0, 0, 1, 0, 0);
          ctx.rotate(90 * Math.PI / 180);
          ctx.fillText(word, yPos - obj.font_size * 0.8, -xPos - obj.font_size * 0.75);
          ctx.restore();
        } else if (word.match(/[、]/)) {
          ctx.fillText(word, xPos + obj.font_size * 0.6 , yPos - obj.font_size * 0.7);
        } else if (word.match(/[A-Za-z0-9ｦ-ｯｱ-ﾝ]/)) {

          const charWidth = ctx.measureText(word).width;

          const adjustXpos = xPos + (obj.font_size / 2) - (charWidth / 2);

          ctx.fillText(word, adjustXpos, yPos);
        } else {
          ctx.fillText(word, xPos, yPos);

          // TODO 「゛」を付ける文字を指定(いらない？)
          // if (nextWord == "゛") {

          // 	/* ** 「゛」は並べて表示 ** */

          // 	ctx.fillText(nextWord, xPos + (obj.font_size * 0.8), yPos);

          // 	// 同一行と列に2文字表示する為、次の文字を表示する為、+1
          // 	colNo = colNo + 1;
          // }
        }
      }
    }
  }

  return canvas.toDataURL("image/png").replace("data:image/png;base64,", "");
}

/************************************************************
 * 縦書きテキスト画像のサイズ取得
 ************************************************************/

export const getTextSizeVertical = ({
  text,
  fontSize,
  lineHeight,
  letterSpacing = 0,
  fontFamily = "serif",
}: GetTextSizeOptions) => {
  
  const charSize = getBaseSizeOfSingleChar(fontSize, fontFamily);
  
  text = text ? text : "クリックして解答を入力してください。";
  const rowCnt = getVerticalRowCnt(text);
	const colCnt = getVerticalColCnt(text);

  const width = (charSize.width + lineHeight) * rowCnt;
	const height = (fontSize + letterSpacing) * colCnt + (fontSize / 32 * 10);

  return new Size(width, height);
}

/************************************************************
 * 縦書きテキスト用の全角1文字あたりのサイズ取得
 ************************************************************/

export const getBaseSizeOfSingleChar = (fontSize: number, fontFamily: string) => {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  ctx.font = `${fontSize}px ${fontFamily}`;

  const char = "あ";
  const charSize = ctx.measureText(char);

  return charSize
}

/************************************************************
 * 縦書きテキストの行数取得
 ************************************************************/

export const getVerticalRowCnt = (text: string) => {

  const textArray = text.split(/\r\n|\r|\n/);
  const rowCnt = textArray.length;

  return rowCnt;
}

/************************************************************
 * 縦書きテキストの列数取得
 ************************************************************/

export const getVerticalColCnt = (text: string) => {

  const textArray = text.split(/\r\n|\r|\n/);
  const colCnt = textArray.reduce((maxCnt, value) => {
    return value.length > maxCnt ? value.length : maxCnt;
  }, 0);

  return colCnt;
}

export class Size {
  width: number
  height: number
  
  constructor(width: number, height: number){
    this.width = width;
    this.height = height;
  }
}

export class Point {
  x: number
  y: number
  
  constructor(x: number, y: number){
    this.x = x;
    this.y = y;
  }
}

export const customAlert = async (bvModal: any, store: any, msg: string) => {
  store.commit("setIsShowingMsgBox", true);
  const result =  await bvModal.msgBoxOk(msg, {autoFocusButton: "ok", id: "msg-box"});
  store.commit("setIsShowingMsgBox", false);
  return result;
}

export const customConfirm = async (bvModal: any, store: any, msg: string, title: string = "確認") => {
  store.commit("setIsShowingMsgBox", true);
  const result =  await bvModal.msgBoxConfirm(msg, {autoFocusButton: "ok", id: "msg-box", title: title});
  store.commit("setIsShowingMsgBox", false);
  return result;
}

export const getCookieValue = (cookies: any, key: string) => {
  
  let rtn: string = null;
  const cookiesArray = cookies.split(';');
  for(let c of cookiesArray){
    const cArray = c.split('=');
    if(cArray[0].trim() == key){
      rtn = cArray[1];
    }
  }
  return rtn;
}

export const arraySplit = <T = object>(array: T[], n: number): T[][] => {
  return array.reduce((acc: T[][], c, i: number) => (i % n ? acc : [...acc, ...[array.slice(i, i + n)]]), []);
}

export const showToast = (bvToast: any, msg: string, title: string = "処理完了", isError = false, toaster = "b-toaster-bottom-right") => {
  bvToast.toast(msg, {
    variant: isError ? "denger" : "success",
    title: title,
    autoHideDelay: 3000,
    autoHide: true,
    appendToast: true,
    solid: true,
    toaster: toaster,
  })
}

const adaptor = liteAdaptor();
RegisterHTMLHandler(adaptor);
const tex = new TeX({packages: AllPackages});
const svg = new SVG({fontCache: 'none'});
const mathDocument = mathjax.document('', {InputJax: tex, OutputJax: svg});

export const convertSvgElementByLaTex = (laTex: string): string => {
  const node = mathDocument.convert(laTex, {display: true});
  return adaptor.outerHTML(node);
};

export enum DrawModeEnum {
  None = 0,
  FreeLine = 1,
  StraightLine = 2,
  Marker = 3,
  Eraser = 4,
  BracesStart = 5,
  BracesEnd = 6,
  Number = 7,
  Delete = 8,
  Text = 9,
  // TextVertical = 10,
  KeyInput = 11, 
  SeitouClick = 12, 
  GotouClick = 13, 
  TokutenClick = 14, 
  Image = 15,
  ScoreStamp = 16,
}

export enum DirectionEnum {
  Horizon = 1,
  Vertical = 2,
}

export enum SaitenModeEnum {
  None = 0,
  KeyInput = 1, 
  SeitouClick = 2, 
  GotouClick = 3, 
  TokutenClick = 4, 
  FreeLine = 5,
  StraightLine = 6,
  BracesStart = 7,
  BracesEnd = 8,
  Number = 9,
  Eraser = 10,
  Text = 11,
  Trash = 12,
}

/************************************************************
 * コンペア採点の採点番号
 * 0: コンペア以外の通常採点
 * 1: コンペアの1次採点(A採点)
 * 2: コンペアの2次採点(B採点)
 * 3: コンペアの最終採点(照合)
 ************************************************************/

export enum CompareNoEnum {
  None = 0,
  CompareFirst = 1,
  CompareSecond = 2,
  CompareFinal = 3,
}

/************************************************************
 * Classroom試験の答案返却先
 * 1: ストリーム
 * 2: 課題
 ************************************************************/

export enum ClassroomReturnTypeEnum {
  Steram = 1,
  CourseWork = 2,
}

/***************************
 * ショートカットキーが使用可能か判定
 * input type="text" or input type="number" or textareaがフォーカスされている場合
 * 入力を優先させるため無効と判定する
 ***************************/

export const isShortcutKeyEnable = (document: Document) => {
  if (document.activeElement instanceof HTMLTextAreaElement ||
    (document.activeElement instanceof HTMLInputElement && ["text", "number"].includes(document.activeElement.type))) {
    return false;
  }else{
    return true;
  }
}

/***************************
 * 文字列とフォントサイズから文字列の横幅の概算を返却
 ***************************/

export const calculateTextWidth = (text: string, zenkakuCharWith: number = 14) => {
  const hankakuCharWidth = 11;
  let width = 0;
  for (const char of text) {
    // 全角: Unicodeが2バイトに分類される（正確にはもっと複雑だが目安として）
    if (char.match(/[^\x01-\x7E\uFF61-\uFF9F]/)) {
      width += zenkakuCharWith;
    } else {
      width += hankakuCharWidth;
    }
  }
  return width;
}

/***************************
 * 採点画面のソート種別
 ***************************/

export enum SaitenInputSortKindEnum {
  No = 1, 
  CorrectState = 2,
  FileSize = 3,
  MarkNo = 4,
}

/***************************
 * PresignedURLから画像をロードし縦横サイズを返却
 ***************************/

export const getImageSizeFromPresignedURL = (url: string): Promise<{ width: number; height: number }> => {
  return new Promise((resolve, reject) => {
    const img = new Image();

    img.onload = () => {
      resolve({ width: img.naturalWidth, height: img.naturalHeight });
    };
    img.onerror = () => reject(new Error("image load failed"));

    img.src = url;
  });
};

export const getImageSizeFromBase64DataUrl = (dataUrl: string): Promise<{ width: number; height: number }> => {
  return new Promise((resolve, reject) => {
    if(!dataUrl || !dataUrl.startsWith("data:image/")){
      reject(new Error("invalid image data url"));
      return;
    }

    const img = new Image();

    img.onload = () => {
      resolve({ width: img.naturalWidth, height: img.naturalHeight });
    };
    img.onerror = () => reject(new Error("image load failed"));

    img.src = dataUrl;
  });
};
